import React, {useEffect, useRef} from 'react';
import Link from 'next/link';
import clsx from 'clsx';
import Container from './Container.jsx';
import DropdownContent from './DropdownContent.jsx';
import {ChevronDown, ChevronUp} from 'lucide-react';
import {useRouter} from 'next/router';
import styles from '@/ui/header-navigation/MegaMenu.module.scss';
import {useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';

const MenuItem = ({
                      label,
                      href,
                      icon,
                      children,
                      onToggle,
                      active,
                      setIsDrawerOpen,
                  }) => {
    const theme = useTheme();
    const router = useRouter();

    const hoverEnterTimeout = useRef(null);
    const hoverLeaveTimeout = useRef(null);

    

    const handleMouseEnter = () => {
        clearTimeout(hoverLeaveTimeout.current);
        hoverEnterTimeout.current = setTimeout(() => {
            onToggle && onToggle(); // keep current index active
        }, 1000); // delay to open
    };

    const handleMouseLeave = () => {
        clearTimeout(hoverEnterTimeout.current);
        hoverLeaveTimeout.current = setTimeout(() => {
            onToggle && onToggle(null); // clear active
        }, 100); // delay to close
    };

    const handleClick = () => {
        const activeElement = document.activeElement;
        if (activeElement) activeElement.blur();
    };

    const isActiveLink = () => href === '/' ? router.pathname === '/' : router.pathname.startsWith(href);

    const gradient = `linear-gradient(${theme.custom.headerActiveItemGradient.direction}, ${theme.custom.headerActiveItemGradient.start}, ${theme.custom.headerActiveItemGradient.end})`;

    useEffect(() => {
        return () => {
            clearTimeout(hoverEnterTimeout.current);
            clearTimeout(hoverLeaveTimeout.current);
        };
    }, []);

    return (
        <li
            // onMouseEnter={handleMouseEnter}
            // onMouseLeave={handleMouseLeave}
        >
            <div
                className={styles.navItemContent}
                style={{
                    backgroundImage: isActiveLink() ? gradient : 'inherit',
                    ...(isActiveLink() ? theme.custom.activeHeaderNavLink : {}),
                    ...theme.custom.headerNavLinks,
                }}
            >
                {icon && icon}
                <Link
                    href={href}
                    className={clsx(styles.link, {[styles.active]: isActiveLink()})}
                    onClick={() => {
                        setIsDrawerOpen && setIsDrawerOpen(false);
                        handleClick();
                    }}
                >
                    {label}
                </Link>

                {children && (
                    <button
                        className={clsx(styles.mdHidden, {[styles.active]: active})}
                        onClick={onToggle}
                        aria-label="Toggle dropdown"
                        aria-haspopup="menu"
                        aria-expanded={active ? 'true' : 'false'}
                    >
                        {active ? <ChevronUp size={20}/> : <ChevronDown size={20}/>}
                    </button>
                )}
            </div>

            {children && (
                <Box
                    role="menu"
                    className={clsx(styles.dropdown, {
                        [styles.hAuto]: active,
                        [styles.active]: active,
                        [styles.h0]: !active,
                        [styles.overflowHidden]: !active,
                        [styles.mdHAuto]: true,
                    })}
                    sx={{
                        ...theme.custom.headerSubMegaNav,
                    }}
                >
                    <Container>
                        <DropdownContent
                            submenuscontent={children}
                            setIsDrawerOpen={setIsDrawerOpen}
                            handleClick={handleClick}
                        />
                    </Container>
                </Box>
            )}
        </li>
    );
};

export default MenuItem;
